import Styleguide, { Colors, theme } from "../theme";
import styled from "styled-components";

const TextMessage = styled.p`
  font-family: ${Styleguide.fonts.body.name};
  font-size: ${Styleguide.fontSizes[16]};
  text-align: center;
  color: ${theme(Colors.gray[400], Colors.white)};
  margin: 0px;

  @media (min-width: ${Styleguide.breakpoints.tablet}) {
    max-width: 312px;
  }

  @media (min-width: ${Styleguide.breakpoints.desktop}) {
    font-size: ${Styleguide.fontSizes[18]};
    text-align: start;
    max-width: 496px;
  }
`;

export default TextMessage;
